import React, { useEffect, useState } from 'react';
import { Balloon, Radio } from '@alifd/next';
import styles from './index.module.scss';

/**
 * opType 固定为 'EQ'
 * @param {*} tagItem 整个标签的信息
 * @param {*} changeData 把组件的值提交到父组件，改变父组件的值
 * @return {*}
 */
const TagRadio = ({
  tagItem = {},
  changeData = (data) => {},
  pageType = ''
}) => {
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id?.[0]); // radio选中的值
  /**
   * 选择时改变要处理成字符串形式传给父组件
   */
  const changeValue = (val) => {
    setData(val);
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
            {
              param_id: [val]
            }
        ]
      },
      opType: 'EQ'
    });
  };

  useEffect(()=>{
    if( pageType==='1' || (pageType ==='2' && !tagItem.opValue)
     ) { // 如果是创建
      if(tagItem.id === '2111' || tagItem.id ==='2121') { // 如果为[新客人群客单价-新客维度] || [老客人群客单价-老客维度] 
        changeValue('1')
      }
    }
  },[pageType])
  return (
    <div className={`${styles['tag-checkbox']} tag-width`}>
      <div className={styles['tag-radio']}>
        <div style={{color:'#ff3333'}}>*</div>
        <div>
          {tagItem.labelName}
          <Balloon.Tooltip
            align="t"
            closable={false}
            trigger={
              <span
                style={{
                  fontSize: '16px',
                  marginLeft: '4px',
                  cursor: 'pointer',
                }}
                className="iconfont icon-icon4-33"
              />
            }
          >
            <div style={{whiteSpace: 'pre-wrap'}}>
              {tagItem.labelDescription}
            </div>
          </Balloon.Tooltip>
        </div>
        :
        <Radio.Group value={data} onChange={(val) => changeValue(val)}>
        {
          tagItem.value.map((its, ins) => (<Radio
            style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
            key={ins}
            value={its.realValue}
          >
            {its.fieldValue}
          </Radio>))
        }
      </Radio.Group>
      </div>

      {
        !data && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelName}
        </div>
      }
    </div>
  );
};
export default TagRadio;
